export default {
    namespaced: true,

    state: {
        data: {
            last_name: "",
            first_name: "",
            middle_name: "",
            birth_date: "",
            phone: "",
            email: "",
            passport_series: "",
            passport_number: "",
            passport_subdivision_code: "",
            passport_subdivision_title: "",
            passport_date: "",
            address: "",
            is_middle_name_required: false,

            passport_photo_files: [],

            passport_address_files: [],

            transaction_date: "",
            transaction_time: "",
            terminal_addres_or_number: "",
            deposit_summ: "",
            deposit_summ_deficit: "0",

            transaction_provider_option: {
                text: null,
                id: null,
                icon: null,
                selected: false,
            },

            transaction_id: "",
            deposit_method_option: {
                text: null,
                id: null,
                selected: false,
            },
            notes_value_and_amount: "",
            terminal_response: "",
            notes_in_packs: false,
            receipt_received: true,

            terminal_deposit_assurance: true,
            terminal_deposit_place: "",

            additional_info: "",
            transaction_document_copy_attached: true,

            transaction_document_files: [],

            no_transaction_document_reason: "",

            pd_agreement: false,
        },

        data_send: false
    },

    actions: {
        async TECHNICAL_FAILURE_SEND_DATA_ACT({ commit, dispatch }, sendData) {
            commit("setDataSend", { bool: false })
            
            try {
                let res = await BX.ajax.runComponentAction("vedita:application", "save", {
                    mode: "class",
                    data: {
                        post: sendData, //данные
                    },
                });
                commit("setDataSend", { bool: true })
            } catch (error) {
                dispatch("errorController/aggregateErrors", { error: error }, { root: true });
            }
        },
    },

    mutations: {
        setFirstStepData(state, { data }) {
            state.data.last_name = data.last_name;
            state.data.first_name = data.first_name;
            state.data.middle_name = data.middle_name;
            state.data.birth_date = data.birth_date;
            state.data.phone = data.phone;
            state.data.email = data.email;
            state.data.passport_series = data.passport_series;
            state.data.passport_number = data.passport_number;
            state.data.passport_subdivision_code = data.passport_subdivision_code;
            state.data.passport_subdivision_title = data.passport_subdivision_title;
            state.data.passport_date = data.passport_date;

            state.data.passport_photo_files = data.passport_photo_files;
            state.data.passport_address_files = data.passport_address_files;

            state.data.address = data.address;
            state.data.is_middle_name_required = data.is_middle_name_required;
        },

        setSecondStepData(state, { data }) {
            state.data.transaction_date = data.transaction_date;
            state.data.transaction_time = data.transaction_time;
            state.data.terminal_addres_or_number = data.terminal_addres_or_number;
            state.data.deposit_summ = data.deposit_summ;
            state.data.deposit_summ_deficit = data.deposit_summ_deficit;

            state.data.transaction_provider_option.text = data.transaction_provider_option.text;
            state.data.transaction_provider_option.id = data.transaction_provider_option.id;
            state.data.transaction_provider_option.icon = data.transaction_provider_option.icon;
            state.data.transaction_provider_option.selected = data.transaction_provider_option.selected;

            state.data.transaction_id = data.transaction_id;

            state.data.deposit_method_option.text = data.deposit_method_option.text;
            state.data.deposit_method_option.id = data.deposit_method_option.id;
            state.data.deposit_method_option.selected = data.deposit_method_option.selected;

            state.data.notes_value_and_amount = data.notes_value_and_amount;
            state.data.terminal_response = data.terminal_response;
            state.data.notes_in_packs = data.notes_in_packs;

            state.data.terminal_deposit_assurance = data.terminal_deposit_assurance;
            state.data.terminal_deposit_place = data.terminal_deposit_place;
            state.data.additional_info = data.additional_info;

            state.data.transaction_document_copy_attached = data.transaction_document_copy_attached;
            state.data.no_transaction_document_reason = data.no_transaction_document_reason;

            state.data.transaction_document_files = data.transaction_document_files;
        },

        setThirdStepData(state, { data }) {
            state.data.pd_agreement = data.pd_agreement;
        },

        setDataSend(state, { bool }) {
            state.data_send = bool;
        },
    },
};
